<div
  *ngIf="item"
  [class.active]="item.state"
  (click)="changeState()"
  class="switch">
  <span class="switch__decor"></span>
  <div class="switch__tooltip">
    <span
      *ngIf="!item.state"
      class="switch__tooltip-text">
      {{onName}}
    </span>
    <span
      *ngIf="item.state"
      class="switch__tooltip-text">
      {{offName}}
    </span>
  </div>
</div>
